<img src="/assets/icons/svet-icon.svg" alt="svet" routerLink="/">

<div id="actions">
    <button (click)="loginService.navToGoogleAuth()">{{'auth.login' | translate }}</button>
    <button (click)="loginService.navToGoogleAuth()" class="fill">{{'auth.register' | translate }}</button>
</div>